<template>
  <div class="">
    <edit-group>
      <!-- <template v-slot:navigation>
        <go-back/>
      </template> -->
    </edit-group>
  </div>
</template>

<script>
import EditGroup from "@/components/wallet/registry-groups/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EditGroup,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Modifica Gruppo",
        path: "registry_groups.edit",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Modifica Gruppo",
        path: "registry_groups.edit",
        level: 4,
      });
    }
  },
};
</script>
